

export const baseURL = "https://api.leonardoribeirodev.com";